import {
  ImprovementsAction,
  ImprovementsState,
} from 'pages/Improvements/_store';
import * as R from 'remeda';
import { timeUtility } from 'utility';

// Default actionboard week: same factory as the deleted store/page/actionboard
// reducer used — the current week stepped back one year, so the simulate tab
// opens on a populated historical window rather than an empty future date.
const currentWeek = timeUtility.factory<Time.Week>({
  ...timeUtility.toTimeDate(new Date()),
  type: 'week',
});
const defaultActionboardSelectedWeek = timeUtility.step({
  timeDate: currentWeek,
  step: 'previous',
  stepSize: 'year',
});

const initialState: ImprovementsState = {
  activeTabId: 'suggestions',
  selectedSuggestionId: null,
  selectedActionId: null,
  selectedAreaIds: [],
  actionboard: {
    selectedWeek: defaultActionboardSelectedWeek,
    selectedEntityId: null,
  },
};

const improvementsReducer = (
  state: ImprovementsState = initialState,
  action: ImprovementsAction,
): ImprovementsState => {
  switch (action.type) {
    case 'page/improvements/SET_ACTIVE_TAB_ID':
      return R.set(state, 'activeTabId', action.payload);
    case 'page/improvements/SET_SELECTED_ACTION_ID':
      return R.set(state, 'selectedActionId', action.payload);
    case 'page/improvements/SET_SELECTED_SUGGESTION_ID':
      return R.set(state, 'selectedSuggestionId', action.payload);
    // Filter-chip state — full replacement, used by the "All" affordance to
    // clear the set; chip clicks go through TOGGLE_SELECTED_AREA_ID.
    case 'page/improvements/SET_SELECTED_AREA_IDS':
      return R.set(state, 'selectedAreaIds', action.payload);
    case 'page/improvements/TOGGLE_SELECTED_AREA_ID': {
      const id = action.payload;
      const next = state.selectedAreaIds.includes(id)
        ? state.selectedAreaIds.filter((existing) => existing !== id)
        : [...state.selectedAreaIds, id];
      return R.set(state, 'selectedAreaIds', next);
    }
    // Actionboard sub-view setters — write into the nested actionboard slice.
    case 'page/improvements/SET_ACTIONBOARD_SELECTED_WEEK':
      return R.setPath(state, ['actionboard', 'selectedWeek'], action.payload);
    case 'page/improvements/SET_ACTIONBOARD_SELECTED_ENTITY_ID':
      return R.setPath(
        state,
        ['actionboard', 'selectedEntityId'],
        action.payload,
      );
    default:
      return state;
  }
};

export default improvementsReducer;
